export const version = "sha2/5.0.8";
//# sourceMappingURL=_version.js.map